import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import SelectScenarioButtonWithConfirmationDialog from './ButtonWithConfirmationDialog';
import SelectScenarioButtonWithRedirect from './ButtonWithRedirect';

const SelectScenarioButtonPicker = ({
  scenarioInsightResource, buttonLabel, onConfirm, loading, disabled,
}) => {
  return pickWithPriority(scenarioInsightResource, [
    [fr.relationships.selectScenario.name,
      <SelectScenarioButtonWithRedirect
        buttonLabel={buttonLabel}
        onConfirm={onConfirm}
        loading={loading}
        disabled={disabled}
      />,
    ],
  ],
    <SelectScenarioButtonWithConfirmationDialog
      buttonLabel={buttonLabel}
      onConfirm={onConfirm}
    />);
};

export default SelectScenarioButtonPicker;
